import React from 'react';
import { motion } from 'framer-motion';

const SolutionsHero = () => {
	return (
		<>
			<section className="relative min-h-screen flex items-center justify-center overflow-hidden py-6 sm:py-8 md:py-12 lg:py-0">
				{/* Background Image */}
				<div className="absolute inset-0 z-0 bottom-0">
					<img
						src="/images/pyramid_prism-colored.png"
						alt="Colorful prism pyramid background"
						className="w-full h-full object-contain opacity-60 sm:opacity-70 md:opacity-80 lg:opacity-100"
						style={{ objectPosition: '50% 80%' }}
					/>
				</div>
				
				{/* Content Overlay */}
				<div className="relative z-10 text-center px-4 sm:px-6 md:px-8 lg:px-6 max-w-6xl mx-auto h-screen sm:h-[80vh] md:h-[90vh] flex flex-col justify-center space-y-8 sm:space-y-10 md:space-y-12 lg:space-y-16
				lg:justify-around xx:justify-center
				">
				
					{/* Main Title Section */}
					<div className="space-y- sm:space-y-6">
						<h1 className="font-source italic leading-tight text-black font-light" style={{ fontSize: 'clamp(3rem, 10vw, 7rem)' }}>
							Clarity
						</h1>
					</div>
				
					{/* Content Section */}
					<div className="space-y-6 sm:space-y-8 md:space-y-10 max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto">
						<motion.h2 
							className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-source font-regular text-black leading-tight font-semibold"
							initial={{ y: 30, opacity: 0 }}
							animate={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						>
							Science-Driven Strategies
						</motion.h2>
						
						<motion.p 
							className="text-base sm:text-lg md:text-xl lg:text-xl font-sans font-regular text-black leading-relaxed px-2 sm:px-4 md:px-6 text-gray-800"
							initial={{ y: 30, opacity: 0 }}
							animate={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
						>
							At Analytical Prism, we harness scientific precision to drive personal and organisational success. By integrating cutting-edge research with practical applications, we empower educators, organisations, and individuals to make informed decisions, optimise performance, and unlock their full potential.
						</motion.p>
					</div>
				</div>
			</section>

		
		</>
	);
};

export default SolutionsHero;
